<template lang="pug">
.app-hero
  .app-hero__form(:class="{ 'has-clear': query }")
    label.app-hero__label {{ options.heroText }}
    .app-hero__search-wrapper
      .app-hero__control
        input.app-hero__input(v-model="model", @keydown.enter.stop.prevent="executeSearch", type="text", :placeholder="options.queryPlaceholderText")
        button.app-hero__submit(@click.stop.prevent="executeSearch", type="submit")
          span.hideVisually {{ options.querySubmitText }}
          i.glyph-search
      button.btn.app-hero__clear(v-if="query", @click.stop.prevent="clearSearch", type="button") Clear Search
</template>

<script>
export default {
  name: 'AppHero',
  props: ["query", "setQuery", "executeSearch",],
  data() {
    return {}
  },
  computed: {
    model: {
      get() {
        return this.query;
      },
      set(value) {
        this.setQuery(value);
      }
    }
  },
  methods: {
    clearSearch() {
      this.setQuery('');
      this.executeSearch();
    }
  }
}
</script>

<style lang="scss" scoped>
.app-hero {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  justify-content: center;
  grid-column: 1 / -1;
  margin: 1rem 0 0;
  max-width: 100%;
  position:relative;

  @include mqdn(sm){
    margin: 1rem !important;
  }

  &__media {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
    z-index: -1;
  }

  @include mqdn(sm){
      margin: 1rem -2rem;
      max-width: unset;

  }
  &__form {
    grid-area: 1 / 1 / 2 / 2;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    gap: 1rem;
    position:relative;
    z-index:2;

    @include mq(md){
      width: calc(100% - 80px);
    }

    &.has-clear {
      padding-bottom: 1rem;

      @include mq(sm) {
        padding-bottom: 2.5rem;
      }

      @include mq(md) {
        padding-bottom: 0;
      }
    }
  }

  &__label {
    @include fluid(font-size, 1.5rem, 2.75rem);
    color: $black;
    font-weight: 700;
  }

  &__search-wrapper {
    display: flex;
    align-items: center;
    position: relative;

    .glyph-search {
      color: #666;
    }
  }

  &__control {
    display: flex;
    flex: 1 1 100%;
    background: $white;
    border: 1px solid $mediumGray;
    transition: border-color 0.2s ease;

    &:focus-within {
      border-color: var(--focus-color);
    }

    .app-hero__input {
      &:focus {
        outline: none;
        box-shadow: none !important;
      }
    }
  }

  &__input {
    appearance: none;
    border: none;
    background: transparent;
    border-radius: 0;
    padding: 0.3875rem 0 0.3875rem 0.75rem;
    flex: 1 1 100%;
    font-size: 1rem;
    width: auto;
    min-width: 0;
    line-height: 1.5;
    &::placeholder {
      font-size: 0.875rem;
    }
    @include mq(sm) {
      padding: 0.625rem 0 0.625rem 1rem;
    }
  }

  &__clear {
    position: absolute;
    right: 0;
    top: 100%;
    margin-top: 0.5rem;
    @include mq(md) {
      top: 50%;
      margin-top: 0;
      transform: translateY(-50%) translateX(calc(100% + 1rem));
    }
  }

  &__submit {
    appearance: none;
    border: none;
    background: transparent;
    border-radius: 0;
    padding: 0 0.5rem;
    font-size: 0.875rem;
    color: $fontColorBase;
    flex: 0 0 auto;
    cursor: pointer;
    @include mq(sm) {
      font-size: 1rem;
    }
  }
}
</style>